module.exports = __webpack_public_path__ + "static/media/logo.b0042c15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 55
// module chunks = 0